//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import {BASIC} from "@/config/constant"
	import promise from '@/axios/promise'

	import {getProjBudgetDataApproval,approveBudget,getProjStagePlanLvlList,apprProcSubmit} from '@/api/pm/budget';
	import {dateFormat} from '@/utils/common';
	import { Toast } from 'mint-ui';

	export default {
		name:'budgetDetail',
		data(){
	      return {
	        taskId: this.$route.query.taskId,
	        taskType: this.$route.query.taskType,
	        taskTopic: this.$route.query.taskTopic,
	        showConfirm:this.$route.query.showConfirm,
	        businessKey:this.$route.query.businessKey,
	        taskDefinitionKey:this.$route.query.taskDefinitionKey,
	        // 预算类型 1：全面预算种类  2：人天预算种类
	        budgetType:'',
	        taskVisible: false,
	        taskHis:[],
	        selects: [],
	        columns: [/*{
	            title: '账号',
	            name: 'userName',
	            width: 80,
	            align: 'center'
	          },*/
	          {
	            title: '名称',
	            name: 'realName',
	            align: 'center'
	          }
	        ],
	        variables:{},
	        msg:"",
	        Index:0,
	        status:"S",
	        nextTaskDatas:[],
	        projId:'',
      		projName:'',

	        mainId: this.$route.query.businessKey,
	      	// 项目起止日期
	      	projStartDate: '',
	      	projEndDate: '',
	      	// 主表数据
	      	budgetData:{},
		    // 阶段数据
		    stageData: [],
	      	// 内部人员数据
	      	inPersonData:[],
	      	// 外部人员数据
	      	outPersonData:[],
	      	// 直接成本数据
	      	costData:[],
	      	// 项目预算数据（月度预算）
	      	budgetCostData:[],
	      	open:false,
	      	// 是否固定 drawer
	      	docked:false,
	      	// drawer 位置
	      	position:'right',
	      	// 激活的项
	      	activeItem:1,
	      	// 项目所跨月份数
	      	sumMonth:0,
	      	//--- 各成本 ---
	      	totalCost:0,
	      	inPersonCost:0,
	      	outPersonCost:0,
	      	otherCost:0,
	      	// 合同总金额
	      	sumContAmt:0,
	      	// 毛利率
	      	gm:'',
	      	openFullscreen:false,
	      	// 人员计划详细数据
	      	personPlanInfo:{},
	      	// 人员计划类型 1：内部人员 2：外部人员
	      	personPlanType:'1',
	      	// 人员月度详情
	      	personMonthData:[],
	      	// 年份数组
	      	yearArr:[],
	      	// 月份数组
	      	monthArr:[],
	      	// 阶段嵌套列表是否显示
	      	itemOpen:'',
	      	itemTwoOpen:'',
	      	// 内部、外部人员数量
	      	inPersonCount:0,
	      	outPersonCount:0,
	      	// 人天预算种类 人员详细
	      	openServiceFullscreen:false,
	      }
		},
		created(){
			// 加载数据
			this.loadData();
		},
		computed:{

		},
		mounted: function(){
		},
		methods:{
			//时间格式化
			dateFormatter(date) {
				return dateFormat(date);
			},
			// 返回
			goback(){
				// 返回工作台
				//this.$router.push({ name:'workbench'});
        		this.$router.go(-1);
			},
		    // 加载数据
		    loadData(){
      			var condition = {'budgetId':this.mainId};
		        getProjBudgetDataApproval(condition).then(response => {
		          // 数据赋值
		          // 预算主表数据
		          this.budgetData = response.projBudgetData;

		          if(this.budgetData.projTypeCate === '人天预算'){
		          	// 人天预算种类
		          	this.budgetType = '2';
		          }else{
		          	// 全面预算种类
		          	this.budgetType = '1';
		          }
		          // *****人天预算种类******
		          if(this.budgetType === '2'){
			          // 内部人员计划数据
			          this.inPersonData = response.personServiceData;
			          this.outPersonData = response.outPersonServiceData;
			          
				      // 内部人员数量
				      this.inPersonCount = this.inPersonData.length;
				      // 外部人员数量
				      this.outPersonCount = this.outPersonData.length;
		          }else{
			          // 内部人员计划数据
			          this.inPersonData = response.inPersonPlanData;
			          // 外部人员计划数据
			          this.outPersonData = response.outPersonPlanData;
			          // 直接成本数据
			          this.costData = response.projCostPlanData;

			          // 合同总金额
			          this.sumContAmt = this.budgetData.sumContAmt;
			          // 各成本
			          this.totalCost = this.budgetData.sumCost;
			          this.inPersonCost = this.budgetData.intLaborCost;
			          this.outPersonCost = this.budgetData.extLaborCost;
			          this.otherCost = this.budgetData.otherCost;

		              // 赋值
		              this.projStartDate = this.budgetData.projStartDate;
		              this.projEndDate = this.budgetData.projEndDate;
	              	  // 项目id
	              	  this.projId = this.budgetData.projId;
			          // 计算月份数
			          this.calcSumMonth();
			          // 计算项目预算
			          this.calcProjBudgetData();

			          // 项目阶段层级数据
			          var query = {'budgetId':this.mainId};
			          getProjStagePlanLvlList(query).then(response => {
			        	  // 数据赋值
			        	  this.stageData = response;
			          });
		          }

		          // 审批显隐控制
				  this.showControl();
		        });
		    },
		    // 点击事件
		    drawerItemClick(v){
		    	this.open = false;
		    	var a = 'state' + v;
		    	 $("html,body").animate({
		        		scrollTop: $('.'+a+'')[0].offsetTop - 44
		        	}, 500);
		    },
		    // 计算项目所跨月份数
		    calcSumMonth(){
		      var startDateArr = this.projStartDate.split('-');
		      var endDateArr = this.projEndDate.split('-');

		      var startYear = Number(startDateArr[0]);
		      var startMonth = Number(startDateArr[1]);
		      var endYear = Number(endDateArr[0]);
		      var endMonth = Number(endDateArr[1]);

		      // 总月数计算
		      this.sumMonth = (12-startMonth+1)+(endYear-startYear-1)*12+endMonth;
		    },
		    // 计算项目预算
		    calcProjBudgetData(){

		      // 初始化数据
		      this.budgetCostData=[];

		      if(this.projStartDate === undefined || this.projStartDate === ''
		        || this.projEndDate === undefined || this.projEndDate === ''){
		        return;
		      }

		      // 内部人员数量
		      this.inPersonCount = this.inPersonData.length;
		      // 外部人员数量
		      this.outPersonCount = this.outPersonData.length;

		      // 内部月份人工成本
		      var inMonthCost = new Array();
	      	  // 差旅补贴月份成本
	      	  var travSubsidyMonthCost = new Array();
		      this.inPersonData.map((v,j)=>{
		        for(var i=1;i<=this.sumMonth;i++){
		          if(inMonthCost[i-1] === undefined){
		            inMonthCost[i-1] = (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }else{
		            inMonthCost[i-1] = inMonthCost[i-1] + (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }

		          // 每个月份的差旅补贴统计
	          	  if(travSubsidyMonthCost[i-1] === undefined){
	            	travSubsidyMonthCost[i-1] = (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0) * (!isNaN(parseInt(v.subsidy))?parseInt(v.subsidy):0);
	          	  }else{
	            	travSubsidyMonthCost[i-1] = travSubsidyMonthCost[i-1] + (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0) * (!isNaN(parseInt(v.subsidy))?parseInt(v.subsidy):0);
	          	  }
		        }
		      });

		      // 外部月份人工成本
		      var outMonthCost = new Array();
		      this.outPersonData.map((v,j)=>{
		        for(var i=1;i<=this.sumMonth;i++){
		          if(outMonthCost[i-1] === undefined){
		            outMonthCost[i-1] = (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }else{
		            outMonthCost[i-1] = outMonthCost[i-1] + (!isNaN(parseInt(v['ym'+i]))?parseInt(v['ym'+i]):0)*(!isNaN(parseFloat(v.settPrice))?parseFloat(v.settPrice):0);
		          }
		        }
		      });

		      // ***********************************预算数据的处理*****************************************

		      var startDateArr = this.projStartDate.split('-');
		      var endDateArr = this.projEndDate.split('-');

		      var startYear = Number(startDateArr[0]);
		      var startMonth = Number(startDateArr[1]);
		      var endYear = Number(endDateArr[0]);
		      var endMonth = Number(endDateArr[1]);

		      // 差旅补贴金额
		      var travSubsidyAmt = 0;
		      var travSubsidyItem = this.costData.find(item =>{
		      	return item.costTypeCode === '001';
		      });
		      if(travSubsidyItem !== undefined){
		      	travSubsidyAmt = parseFloat(travSubsidyItem.cost);
		      }

		      // 每月的其他费用，取整，最后一个月另算
		      //△//var monthOtherCost = parseInt(parseFloat(this.otherCost)/this.sumMonth);
		      var partOtherCost = parseFloat((this.otherCost - travSubsidyAmt).toFixed(2));
			  var monthOtherCost = parseFloat((partOtherCost/this.sumMonth).toFixed(2));
		      // 最后一个月 其他费用
		      var lastMonthOtherCost = parseFloat((partOtherCost - monthOtherCost*(this.sumMonth-1)).toFixed(2));
		      // 月列头处理
		      var index = 0;

			  // 直接成本中需要按月平分的处理
		      // 差旅交通
		      var travTraffic = 0;
		      // 驻地交通
		      var resiTraffic = 0;
		      // 住宿杂项
		      var stayExtras = 0;
		      // 其他费用
		      var otherItem = 0;
		      this.costData.map((v,i)=>{
		        if(v.costTypeCode === '002'){
		          // 差旅交通费
		          travTraffic = v.cost;
		        }
		        if(v.costTypeCode === '003'){
		          // 驻地交通费
		          resiTraffic = v.cost;
		        }
		        if(v.costTypeCode === '004'){
		          // 住宿杂项费
		          stayExtras = v.cost;
		        }
		        if(v.costTypeCode === '005'){
		          // 其他费用
		          otherItem = v.cost;
		        }
		      });
		      // 平均每月
		      var travTrafficMonth = parseFloat((parseFloat(travTraffic)/this.sumMonth).toFixed(2));
		      // 最后一个月
		      var lastTravTrafficMonth = parseFloat((travTraffic - travTrafficMonth*(this.sumMonth-1)).toFixed(2));

		      var resiTrafficMonth = parseFloat((parseFloat(resiTraffic)/this.sumMonth).toFixed(2));
		      var lastResiTrafficMonth = parseFloat((resiTraffic - resiTrafficMonth*(this.sumMonth-1)).toFixed(2));

		      var stayExtrasMonth = parseFloat((parseFloat(stayExtras)/this.sumMonth).toFixed(2));
		      var lastStayExtrasMonth = parseFloat((stayExtras - stayExtrasMonth*(this.sumMonth-1)).toFixed(2));

		      var otherItemMonth = parseFloat((parseFloat(otherItem)/this.sumMonth).toFixed(2));
		      var lastOtherItemMonth = parseFloat((otherItem - otherItemMonth*(this.sumMonth-1)).toFixed(2));

		      if(startYear != endYear){

		        for(var i=startMonth;i<=12;i++){
		          index++;
		          var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		          var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		          var item = {year:startYear,month:i,
					totalCost: parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		          this.budgetCostData.push(item);

		          this.yearArr.push(startYear);
		          this.monthArr.push(i);
		        }

		        for(var i=startYear+1;i<endYear;i++){
		          for(var j=1;j<=12;j++){
		            index++;
		            var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		            var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  	var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		            var item = {year:i,month:j,
					totalCost: parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		            this.budgetCostData.push(item);

			        this.yearArr.push(i);
			        this.monthArr.push(j);
		          }
		        }

		        for(var i=1;i<=endMonth;i++){
		          index++;
		          var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		          var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		          var item = {year:endYear,month:i,
					totalCost: parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		          this.budgetCostData.push(item);

			      this.yearArr.push(endYear);
			      this.monthArr.push(i);
		        }
		      }else{
		        
		        for(var i=startMonth;i<=endMonth;i++){
		          index++;
		          var inCost = parseFloat(inMonthCost[index-1]==undefined?0:inMonthCost[index-1].toFixed(2));
		          var outCost = parseFloat(outMonthCost[index-1]==undefined?0:outMonthCost[index-1].toFixed(2));
				  var travCost = parseFloat(travSubsidyMonthCost[index-1]==undefined?0:travSubsidyMonthCost[index-1].toFixed(2));
		          var item = {year:startYear,month:i,
					totalCost: parseFloat((inCost+outCost+travTrafficMonth+resiTrafficMonth+stayExtrasMonth+otherItemMonth+travCost).toFixed(2)),
		            inPersonCost:inCost,outPersonCost:outCost, 
    				travSubsidyCost:travCost,travTrafficCost:travTrafficMonth,resiTrafficCost:resiTrafficMonth,
    				stayExtrasCost:stayExtrasMonth,otherItemCost:otherItemMonth};
		          this.budgetCostData.push(item);

			      this.yearArr.push(startYear);
			      this.monthArr.push(i);
		        }
		      }

		      // 最后一个月的 其他费用、总费用 赋值
      		  var travLastCost = parseFloat(travSubsidyMonthCost[this.sumMonth-1]==undefined?0:travSubsidyMonthCost[this.sumMonth-1].toFixed(2));
      		  this.budgetCostData[this.sumMonth-1].travTrafficCost = lastTravTrafficMonth;
		      this.budgetCostData[this.sumMonth-1].resiTrafficCost = lastResiTrafficMonth;
		      this.budgetCostData[this.sumMonth-1].stayExtrasCost = lastStayExtrasMonth;
		      this.budgetCostData[this.sumMonth-1].otherItemCost = lastOtherItemMonth;
		      this.budgetCostData[this.sumMonth-1].totalCost = parseFloat((this.budgetCostData[this.sumMonth-1].inPersonCost 
		        +this.budgetCostData[this.sumMonth-1].outPersonCost+ travLastCost+lastTravTrafficMonth+lastResiTrafficMonth
        		+lastStayExtrasMonth+lastOtherItemMonth).toFixed(2));

	          // 毛利率计算
	          if(isNaN(this.sumContAmt) || this.sumContAmt === '' || this.sumContAmt === 0){
	          	this.gm = '-';
	          }else{
	          	this.gm = (((this.sumContAmt-this.totalCost)/this.sumContAmt)*100).toFixed(2)+'%';
	          }
		    },
		    // 人员计划详细点击事件
		    personItemClick(item,type){
		    	this.personPlanType = type;
		    	this.personPlanInfo = item;

		    	// 获取月度数据
		    	this.personMonthData=[];
		    	for(var i=0;i<this.sumMonth;i++){
		    		var itemInfo = {year:this.yearArr[i],month:this.monthArr[i],workDays:item["ym"+(i+1)]};
		    		this.personMonthData.push(itemInfo);
		    	}

		    	this.openFullscreen = true;
		    },
		    // 人天预算种类 人员计划详细事件
		    personServiceItemClick(item,type){
		    	this.personPlanType = type;
		    	this.personPlanInfo = item;
		    	this.openServiceFullscreen = true;
		    },
		    // 月度计划成本明细
		    budgetItemClick(id){

		    },
		    // 直接成本明细
		    costItemClick(id){

		    },

		    // *****************审批处理*******************
		    openAlertDialog() {
		        this.taskVisible = true;
		    },
		    closeAlertDialog() {
		    	this.taskVisible = false;
		    },
		    // 界面显隐控制
		    showControl(){
				// 已审批情况
				if(this.taskType === 'done'){
					$(".bottomNav").css('display','none');
				}
		    },
            // 提交
            submitClick(){
                var condition = {budgetId:this.budgetData.id,projId:this.budgetData.projId};
                apprProcSubmit(condition).then(response => {
                    if(response.flag === 'S'){
                        // 提交情况下
                        Toast({
                          message: '提交成功！',
                          position: 'middle',
                          duration: 1500,
                          className:'success'
                        });
                        // 返回列表界面
                        this.goback();
                    }else{
                        Toast({
                          message: '提交失败：'+response.msg,
                          position: 'middle',
                          duration: 1500,
                          className:'warning'
                        });
                    }
                });
            },
           // 同意
		   agreeTask:function(){
	        this.status="S";
	        this.variables.status=this.status;
	        if(this.showConfirm==0){
	          this.taskVisible=true;
	          this.getNextTaskDatas();
	        }else{
	          this.completeTask();
	        }     
	      },
	      // 拒绝
	      refuseTask:function(){
	        this.status="E";
	        this.variables.status=this.status;
	        this.taskVisible=true;
	        this.getNextTaskDatas();
	      },
	      completeTask:function(){
	        var map={};
	        map.variables=this.variables;
	        promise({
	          url:BASIC+"/task/completeTaskByTaskId?taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
	          method:"post",
	          headers:{"Content-Type": "application/json" },
	          data:JSON.stringify(map),
	        }).then(res=>{
	            if(res.code==0){
	              this.taskVisible=false;
	              // 数据处理
	              this.approveDeal();
	             }else{
	                // Message({message:res.msg,type:"error"});
	             }
	        });
	      },
	      IndexClick:function(index){
	        this.Index=index;
	      },
	      taskConfirm:function(){
	        //获取页面传递过来的变量
	        var map={};
	        //审核意见
	        //循环获取每个任务的办理人和任务主题
	        var topics={};
	        var variables=this.variables;
	        var flag=0;//0正常 1任务配置 2任务主题 3办理人
	        var msg="";
	        $.each(this.nextTaskDatas,function(index,row){
	          var task=row.task;
	          var taskKey=task.taskDefinitionKey;
	          var taskName=task.taskName;
	          var actDicTask= row.actDicTask;
	          if(taskKey!='end'){
	            if(actDicTask==null){
	              flag=1;
	              msg="请配置该流程的"+taskName+"节点任务信息";
	              return;
	            }else if(actDicTask.taskType==null || actDicTask.taskType==''){
	              flag=1;
	              msg="请配置该流程的"+taskName+"节点任务任务类型";
	              return;
	            }else if(actDicTask.userExpKey==null || actDicTask.userExpKey==''){
	              flag=1;
	              msg="请配置该流程的"+taskName+"节点任务办理人方式";
	              return;
	            }else{
	              //设置任务主题
	              var taskTopic=task.taskTopic;
	              if(taskTopic==null || taskTopic==''){
	                flag=2;
	                msg=taskName+"节点任务主题不能为空";
	                return;
	              }
	              topics[taskKey]=taskTopic;
	              //任务办理人
	              var taskType=actDicTask.taskType;
	              var userExpKey=actDicTask.userExpKey;
	              var data =[];
	              var checkedUsers=row.checkedUsers;
	              if(checkedUsers!=null && checkedUsers.length>0){
	                $.each(row.users,function(index,user){
	                  $.each(checkedUsers,function(index1,userIndex){
	                    if(userIndex==index){
	                      data.push(user);
	                    }
	                  });
	                });
	              }
	              if(taskType=='Multi'){
	                if(data==null || data.length==0){
	                  flag=3;
	                  msg=taskName+"节点任务办理人不能为空";
	                  return;
	                }else {
	                  var userVal="";
	                  for (var i = 0; i < data.length; i++) {
	                    var user=data[i];
	                    if(i==0){
	                      userVal+=user.userName;
	                    }else{
	                      userVal=userVal+","+user.userName
	                    }
	                  }
	                  variables[userExpKey]=userVal;
	                }
	              }else{
	                if(data==null || data.length==0){
	                  flag=3;
	                  msg=taskName+"节点任务办理人不能为空";
	                  return;
	                }else if(data.length>1){
	                  flag=3;
	                  msg=taskName+"节点为单人任务";
	                  return;
	                }else{
	                  variables[userExpKey]=data[0].userName;
	                }
	              }
	            }
	          }else{
	            var taskTopic=task.taskTopic;
	            if(taskTopic==null || taskTopic==""){
	              taskTopic="结束"
	            }
	            topics.end=taskTopic;
	          }
	        });
	        if(flag!=0){
	          // Message({message:msg,type:"error"});
	          return;
	        }
	        //任务主题
	        //设置流程办理人
	        map.taskTopics=topics;
	        map.variables=variables;
	        this.taskVisible=false;
	        promise({
	          url:BASIC+"/task/completeTaskByTaskId?taskId="+this.taskId+"&msg="+this.msg+"&status="+this.status,
	          method:"post",
	          headers:{"Content-Type": "application/json" },
	          data:JSON.stringify(map),
	        }).then(res=>{
	            if(res.code==0){
	              this.taskVisible=false;
	              // 数据处理
	              this.approveDeal();
	             }else{
	                // Message({message:res.msg,type:"error"});
	             }
	        });
	      },
	      // 审批通过后的数据处理
	      approveDeal(){
	      	var taskKey = this.taskDefinitionKey;
	        var data = {'taskId':this.businessKey,'isPass':this.status,'taskKey':taskKey,'projId':this.projId};
	        approveBudget(data).then(response => {
	          if(response.flag === 'S'){
	            Toast({
				  message: '操作成功！',
				  position: 'middle',
				  duration: 1500,
				  className:'success'
				});
	            this.goback();
	          }else{
	            Toast({
				  message: '预算审批数据处理失败：'+response.msg,
				  position: 'middle',
				  duration: 1500,
				  className:'warning'
				});
	          }
	        });
	      },
	      getTaskTopic:function(task,taskTopicExp){
	        if(task!=null){
	          var commitUser=task.commitUser;
	          if(commitUser==null || commitUser==''){
	            status='F';
	          }
	        }
	        var taskTopic='';
	        if(taskTopicExp==null || taskTopicExp==''){
	          taskTopic=task.processDefinitionName+":"+task.taskName+":"+task.commitUserName;
	        }else{
	          var expArr=taskTopicExp.split(":");
	          for (var i = 0; i < expArr.length; i++) {
	            var exp=expArr[i];
	            if(i==expArr.length-1){
	              if(exp==null || exp==''){
	                continue;
	              }else if(exp=="procName"){
	                taskTopic=taskTopic+task.processDefinitionName;
	              }else if(exp=="taskName"){
	                taskTopic=taskTopic+task.taskName;
	              }else if(exp=="commitUser"){
	                taskTopic=taskTopic+task.commitUserName;
	              }else{
	                var expVal=$("#"+exp).val();
	                if(expVal!=undefined && expVal!=null && expVal!=""){
	                 taskTopic=taskTopic+expVal;
	                }
	              }
	            }else{
	              if(exp==null || exp==''){
	                continue;
	              }else if(exp=="procName"){
	                taskTopic=taskTopic+task.processDefinitionName+":";
	              }else if(exp=="taskName"){
	                taskTopic=taskTopic+task.taskName+":";
	              }else if(exp=="commitUser"){
	                taskTopic=taskTopic+task.commitUserName+":";
	              }else{
	                var expVal=$("#"+exp).val();
	                if(expVal!=undefined && expVal!=null && expVal!=""){
	                  taskTopic=taskTopic+expVal+":";
	                }
	              }
	            }
	          }
	        }
	        return taskTopic;
	      },
	      getNextTaskDatas:function(){
	        var str=JSON.stringify(this.variables);
	        promise({
	          url:BASIC+"/task/getConfirmInfo?taskId="+this.taskId+"&status="+this.status,
	          method:"post",
	          headers:{"Content-Type": "application/json" },
	          data:str
	        }).then(res=>{
	          var code =res.code;
	          if(code==0){
	            this.nextTaskDatas=res.data;
	            var self=this;
	            $.each(this.nextTaskDatas,function(index,row){
	              var taskTpc = '';
                  if(row.actDicTask !== null){
                    taskTpc = row.actDicTask.taskTopic;
                  }
                  var taskTopic=self.getTaskTopic(row.task,taskTpc);
	              row.task.taskTopic=taskTopic;
	            });
	          }else{
	            // Message({message:res.msg,type:"error",duration:1000});
	          }
	         });
	      },
    	}
	}



// WEBPACK FOOTER //
// ./src/view/pm/budget/budgetApproval.vue